// extracted by mini-css-extract-plugin
module.exports = {"barchart":"styles_barchart__2Hqux","noData":"styles_noData__31thi"};